import type { FC, ReactNode } from 'react'

import Link from 'next/link'

/*
  Shared "Try ... for 14 days" call-to-action. Appears identically on the
  about, features, blog and contact pages in the original template.
*/
export const CtaSection: FC = (): ReactNode => {
    return (
        <div className='section'>
            <div className='container'>
                <div className='cta-holder'>
                    <div className='w-layout-grid connection-grid'>
                        <div
                            id='w-node-_300e5558-d91e-378d-4ac7-dd4e067d8ec1-067d8ebd'
                            className='heading-button-wrapper'
                        >
                            <h2 className='outfit-light-weight'>Try Landingfolio for 14 days, no credit card required.</h2>
                            <div className='buttons-holder'>
                                <Link href='/pricing' className='button arrow w-button'>
                                    Start for FREE
                                </Link>
                                <Link href='/pricing' className='gradient-link w-inline-block'>
                                    <div className='button-gradient' />
                                    <div className='button-content-holder'>
                                        <div className='link-gradient-text'>Pricing List</div>
                                    </div>
                                    <div className='white-background-button-color' />
                                </Link>
                            </div>
                        </div>
                        <div className='line-gradient' />
                        <div className='cta-list-holder'>
                            <div className='cta-list-item'>
                                <div className='check-holder'>
                                    <div className='icon-text-wrapp'>
                                        <img src='/images/Gradient-Line-Image.svg' loading='lazy' alt='' className='feature-image-project' />
                                        <div className='managment-holder'>
                                            <p>Unlimited data records and monitorations in your system</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className='cta-list-item'>
                                <div className='check-holder'>
                                    <div className='icon-text-wrapp'>
                                        <img src='/images/Drawing-Gradient-Image.svg' loading='lazy' alt='' className='feature-image-project' />
                                        <div className='managment-holder'>
                                            <p>Fully customizable for your company&rsquo;s needs and your projects</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className='cta-list-item'>
                                <div className='check-holder'>
                                    <div className='icon-text-wrapp'>
                                        <img src='/images/Dollar-Gradient-Image.svg' loading='lazy' alt='' className='feature-image-project' />
                                        <div className='managment-holder'>
                                            <p>One plan for all your needs, with no extra fees at the end of the month</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}
